module.exports = __webpack_public_path__ + "static/media/Wood Black 4.09317923.jpg";